
import {
  Box,
  Flex,
  Avatar,
  HStack,
  Heading,
  Container,
  Text,
  IconButton,
  Button,
  Menu,
  MenuButton,
  MenuList,
  Image,
  MenuItem,
  MenuDivider,
  Input,
  useDisclosure,
  createIcon,
  useToast,
  Icon,
  Link,
  useColorModeValue,
  Stack,
} from "@chakra-ui/react";
import '@livekit/components-styles';
import {
  ControlBar,
  GridLayout,
  LiveKitRoom,
  ParticipantTile,
  RoomAudioRenderer,
  VideoConference,

} from '@livekit/components-react';

const serverUrl = 'wss://pindodg-g5szeweq.livekit.cloud';
const token = 'eyJhbGciOiJIUzI1NiJ9.eyJ2aWRlbyI6eyJyb29tSm9pbiI6dHJ1ZSwicm9vbSI6InF1aWNrc3RhcnQtcm9vbSJ9LCJpc3MiOiJBUElKTm9XR3RCMnlYZ0EiLCJleHAiOjE3MDk0OTc5MDYsIm5iZiI6MCwic3ViIjoicXVpY2tzdGFydC11c2VybmFtZSJ9.w7J6862RkwOy2AUDSdj_xovM6NpoQSbry2KGITd_UNU';



export default function LivePage() {



  return (
    <>
      <Box h={"100vh"}  overflowY={"hidden"}>
      <LiveKitRoom
      video={true}
      audio={true}
      token={token}
      serverUrl={serverUrl}
      // Use the default LiveKit theme for nice styles.
      data-lk-theme="default"
      style={{ height: '100vh' }}
    >
      {/* Your custom component with basic video conferencing functionality. */}

      {/* The RoomAudioRenderer takes care of room-wide audio for you. */}
      <RoomAudioRenderer />
      {/* Controls for the user to start/stop audio, video, and screen 
      share tracks and to leave the room. */}
      <ControlBar />
    </LiveKitRoom>


      </Box>
    </>
  );
}


